<template>
  <div class="about">
    <!-- 页面标题 -->
    <!-- <div class="page-header">
      <h1>关于我们</h1>
      <p>了解我们的企业文化和团队</p>
    </div> -->
    
    <!-- 企业简介模块 -->
    <section class="about__intro">
      <div class="container">
        <h2 class="section-title">企业简介</h2>
        <div class="intro-content">
          <div class="intro-text">
            <h3>{{ companyInfo.name }}</h3>
            <p>{{ companyInfo.description }}</p>
            <div class="company-details">
              <div class="detail-item">
                <h4>企业使命</h4>
                <p>{{ companyInfo.mission }}</p>
              </div>
              <div class="detail-item">
                <h4>企业愿景</h4>
                <p>{{ companyInfo.vision }}</p>
              </div>
              <div class="detail-item">
                <h4>核心价值观</h4>
                <p>{{ companyInfo.values }}</p>
              </div>
            </div>
          </div>
          <div class="intro-image">
            <img :src="companyInfo.image" :alt="companyInfo.name">
          </div>
        </div>
      </div>
    </section>

    <!-- 发展历程时间线 -->
    <section class="about__timeline">
      <div class="container">
        <h2 class="section-title">发展历程</h2>
        <div class="timeline">
          <div 
            v-for="(event, index) in timeline" 
            :key="event.id"
            class="timeline-item"
            :class="{ 'timeline-item--left': index % 2 === 0, 'timeline-item--right': index % 2 === 1 }"
          >
            <div class="timeline-content">
              <div class="timeline-date">{{ event.date }}</div>
              <h3>{{ event.title }}</h3>
              <p>{{ event.description }}</p>
            </div>
            <div class="timeline-dot"></div>
          </div>
        </div>
      </div>
    </section>

    <!-- 核心团队展示 -->
    <section class="about__team">
      <div class="container">
        <h2 class="section-title">核心团队</h2>
        <div class="team-list">
          <div 
            v-for="member in team" 
            :key="member.id"
            class="team-member"
          >
            <div class="member-image">
              <img :src="member.avatar" :alt="member.name">
            </div>
            <div class="member-info">
              <h3>{{ member.name }}</h3>
              <p class="member-position">{{ member.position }}</p>
              <p class="member-description">{{ member.description }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mockApi } from '../api/mock.js'

export default {
  name: 'About',
  components: {},
  data() {
    return {
      companyInfo: {
        name: '',
        description: '',
        mission: '',
        vision: '',
        values: '',
        image: ''
      },
      timeline: [],
      team: []
    }
  },
  mounted() {
    this.fetchAboutData()
  },
  methods: {
    async fetchAboutData() {
      try {
        const response = await mockApi.getAboutData()
        if (response.code === 200) {
          this.companyInfo = response.data.companyInfo
          this.timeline = response.data.timeline
          this.team = response.data.team
        }
      } catch (error) {
        console.error('获取关于我们数据失败:', error)
      }
    }
  }
}
</script>

<style scoped>
.about {
  padding: 0;
}

.page-header {
  text-align: center;
  padding: 40px 20px;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  margin-bottom: 0;
}

.page-header h1 {
  font-size: 36px;
  color: #333;
  margin-bottom: 10px;
}

.page-header p {
  font-size: 16px;
  color: #666;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.section-title {
  text-align: center;
  font-size: 36px;
  font-weight: 600;
  margin-bottom: 40px;
  color: #333;
  position: relative;
}

.section-title::after {
  content: '';
  display: block;
  width: 80px;
  height: 4px;
  /* background: #007bff; */
  margin: 10px auto 0;
  border-radius: 2px;
}

/* 企业简介模块 */
.about__intro {
  padding: 40px 20px;
  margin-bottom: 60px;
}

.intro-content {
  display: flex;
  flex-wrap: wrap;
  gap: 40px;
  align-items: center;
}

.intro-text {
  flex: 1;
  min-width: 300px;
}

.intro-text h3 {
  font-size: 1.8rem;
  margin-bottom: 20px;
  color: #333;
}

.intro-text p {
  font-size: 1.1rem;
  line-height: 1.6;
  margin-bottom: 30px;
  color: #666;
}

.company-details {
  display: flex;
  flex-wrap: wrap;
  gap: 30px;
}

.detail-item {
  flex: 1;
  min-width: 200px;
  background: #fff;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.detail-item h4 {
  font-size: 1.2rem;
  margin-bottom: 10px;
  color: #333;
}

.detail-item p {
  font-size: 1rem;
  margin: 0;
  color: #666;
}

.intro-image {
  flex: 1;
  min-width: 300px;
}

.intro-image img {
  width: 100%;
  height: auto;
  border-radius: 8px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.15);
}

/* 发展历程时间线 */
.about__timeline {
  margin-bottom: 60px;
}

.timeline {
  position: relative;
  max-width: 1200px;
  margin: 0 auto;
}

.timeline::after {
  content: '';
  position: absolute;
  width: 4px;
  background-color: #e0e0e0;
  top: 0;
  bottom: 0;
  left: 50%;
  margin-left: -2px;
  border-radius: 2px;
}

.timeline-item {
  position: relative;
  width: 50%;
  padding: 20px 40px;
  box-sizing: border-box;
}

.timeline-item--left {
  left: 0;
}

.timeline-item--right {
  left: 50%;
}

.timeline-content {
  padding: 20px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  position: relative;
}

.timeline-content::after {
  content: '';
  position: absolute;
  width: 20px;
  height: 20px;
  background-color: #fff;
  border: 4px solid #007bff;
  top: 25px;
  border-radius: 50%;
  z-index: 1;
}

.timeline-item--left .timeline-content::after {
  right: -14px;
}

.timeline-item--right .timeline-content::after {
  left: -14px;
}

.timeline-date {
  font-size: 0.9rem;
  color: #007bff;
  font-weight: bold;
  margin-bottom: 10px;
}

.timeline-content h3 {
  font-size: 1.3rem;
  margin-bottom: 10px;
  color: #333;
}

.timeline-content p {
  font-size: 1rem;
  line-height: 1.5;
  color: #666;
  margin: 0;
}

.timeline-dot {
  position: absolute;
  width: 20px;
  height: 20px;
  background-color: #007bff;
  border: 4px solid #fff;
  top: 30px;
  border-radius: 50%;
  z-index: 2;
}

.timeline-item--left .timeline-dot {
  right: -10px;
}

.timeline-item--right .timeline-dot {
  left: -10px;
}

/* 核心团队展示 */
.about__team {
  background: #f9f9f9;
  padding: 60px 0;
}

.team-list {
  display: flex;
  flex-wrap: wrap;
  gap: 30px;
  justify-content: center;
}

.team-member {
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 15px rgba(0, 0, 0, 0.1);
  width: calc(33.333% - 20px);
  min-width: 280px;
  transition: transform 0.3s ease;
}

.team-member:hover {
  transform: translateY(-5px);
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.15);
}

.member-image {
  height: 200px;
  overflow: hidden;
}

.member-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.team-member:hover .member-image img {
  transform: scale(1.1);
}

.member-info {
  padding: 20px;
}

.member-info h3 {
  font-size: 1.3rem;
  margin-bottom: 5px;
  color: #333;
}

.member-position {
  font-size: 0.9rem;
  color: #007bff;
  margin-bottom: 10px;
}

.member-description {
  font-size: 1rem;
  line-height: 1.5;
  color: #666;
  margin: 0;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .section-title {
    font-size: 2rem;
  }

  .intro-content {
    flex-direction: column;
  }

  .company-details {
    flex-direction: column;
  }

  .timeline::after {
    left: 31px;
  }

  .timeline-item {
    width: 100%;
    padding-left: 70px;
    padding-right: 25px;
  }

  .timeline-item--right {
    left: 0;
  }

  .timeline-content::after {
    left: -14px;
  }

  .timeline-dot {
    left: 21px;
  }

  .team-member {
    width: calc(50% - 15px);
  }
}

@media (max-width: 480px) {
  .section-title {
    font-size: 1.8rem;
  }

  .team-member {
    width: 100%;
  }

  .timeline-item {
    padding-left: 60px;
  }
}
</style>